export {default} from "./infoBlock";
